import { useRouter } from "next/router";
import { useContext } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import constants from "src/constants";
import { SearchContext } from "src/contexts/SearchContext";
import translate from "src/functions/translate";
import SearchIcon from "src/icons/Search";
import { sFormGroup } from "src/styles/sFormGroup.module.scss";
import { sFormSearch, spinner } from "src/styles/sFormSearch.module.scss";

function Search() {
  const { locale } = useRouter();
  const { query, setQuery, lectures, instructors } = useContext(SearchContext);
  return (
    <Form
      inline={true}
      className={sFormSearch}
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <Form.Group className={sFormGroup}>
        <Form.Control
          id="global-search-input"
          as={`input`}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
          placeholder={translate(`Search content`, locale)}
        />
        <Button type={`submit`} variant="link">
          {query && (lectures.loading || instructors.loading) ? (
            <Spinner animation={`border`} className={spinner} />
          ) : (
            <SearchIcon size={20} color={constants.Theme._default} />
          )}
        </Button>
      </Form.Group>
    </Form>
  );
}

export default Search;
